export class Contact{
    Nombre: string;
    Email: string;
    Ciudad: string;
    Mensaje: string;
    Telefono: string;
}